import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Promo } from '../../types'
import ActionTypes from './actionTypes'

type FetchPromoIDRequest = {
    type: typeof ActionTypes.PROMO_ID_FETCH_REQUEST;
    payload: never;
}

type FetchPromoIDFailure = {
    type: typeof ActionTypes.PROMO_ID_FETCH_FAILURE;
    payload: Error;
}

type FetchPromoIDSuccess = {
    type: typeof ActionTypes.PROMO_ID_FETCH_SUCCESS;
    payload: Promo;
}

/**
 * Fetch one promo given its ID
 */
function fetchPromo(id: number) {
    return createAction<RootState, Promo[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/promos/${id}`,
        method: 'GET',
        types: [
            ActionTypes.PROMO_ID_FETCH_REQUEST,
            ActionTypes.PROMO_ID_FETCH_SUCCESS,
            ActionTypes.PROMO_ID_FETCH_FAILURE,
        ],
    })
}

export type FetchPromoIDAction = FetchPromoIDRequest
    | FetchPromoIDFailure
    | FetchPromoIDSuccess

export default fetchPromo
